import React from 'react';
import classNames from 'classnames';
import { GradientPopover } from '../../../../components/Popover/GradientPopover';
import { BaseInputProps } from './BaseInput';
import { GradientType } from '../../types';
import { isValidGradient } from '../../utils';

export const GradientInput: React.FC<BaseInputProps<GradientType>> = ({ instance, onChange, disabled = false, className }) => {
  const { config, value } = instance;

  const handleGradientChange = (gradient: GradientType) => {
    onChange(gradient);
  };

  return (
    <div className={classNames('flex items-center', className)}>
      <GradientPopover gradientValue={isValidGradient(value) ? value : 'SPECTRAL'} onChange={handleGradientChange} disabled={disabled || config.disabled} />
      {instance.isMixed && <span className="ml-2 text-xs text-gray-400 dark:text-gray-500 italic">Mixed</span>}
    </div>
  );
};
